import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import toSlugCase from 'to-slug-case';

import { set_job_store } from '../../actions';
import { db } from './../../config/firebaseConfig';
import { client } from './../../contentful/contentful';

const Job = () => {

    const dispatch = useDispatch();
    const [jobs, setJobs] = useState([]);
    const [paginationNumber,setPaginationNumber] = useState(0);
    const [paginationItems,setPaginationItems] = useState([]);
    const [pageNumberActive,setPageNumberActive] = useState(1);
    const [subcribeEmail,setSubscribeEmail] = useState('');
    const [skip,setSkip] = useState(0);
    const [disableBtn,setDisableBtn] = useState(false);
    const [loading,setLoading] = useState(true);
    const set_job_redux = (job) => dispatch( set_job_store(job) );
    const [emailSubmitted,setEmailSubmitted] = useState(false);
    const [emailSubscribeError,setEmailSubcribeError] = useState("");
  
    const calculatePaginationNumber = (numberOfRecords) =>{
      let paginationNumber = (numberOfRecords / 8);
      if( paginationNumber % 1 !== 0 ){
        paginationNumber += 1;
        setPaginationNumber(Number(Math.trunc(paginationNumber)));
      }else{
        setPaginationNumber(paginationNumber);
      }
    }
  
    useEffect( () =>{ 
      try {
        client.getEntries({
          limit: 8,
          skip,
          'content_type': 'jobPosting'
        }).then( response =>{
          setJobs(response.items);
          calculatePaginationNumber(response.total);
          setLoading(false);
        });
        renderPageNumbersItems();
        window.scrollTo(0, 0);
      } catch (error) {
        console.log('error obteniendo jobs ' + error);
      }
    },[paginationNumber,skip]);

    const saveEmail = async () =>{
      if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(subcribeEmail))){
          setEmailSubcribeError("Error: Debe ingresar un email válido");
          setDisableBtn(false);
          return;
      }
      setEmailSubcribeError("");
      await db.collection('jobs-newsletter').doc().set({
        email : subcribeEmail
      }).then(response =>{
        setDisableBtn(false);
        setSubscribeEmail("");
        setEmailSubmitted(true);
        setTimeout( ()=>{
          setEmailSubmitted(false);
        },3000);
      });
    }
  
    const renderPageNumbersItems = (pageNumber = pageNumberActive) =>{
      let pagNumberAux = [];
      for( let i = 1 ; i <= paginationNumber ; i ++){
        pagNumberAux.push(
          <li className={"page-item" + (pageNumber === i ? ' active' : '' )}>
            <a className="page-link" onClick={ () => skipPage(i)} >
              {i}
            </a>
          </li>
        );
      }
      setPaginationItems(pagNumberAux);
    }
  
    const skipPage = (paginationItem) =>{
      if(paginationItem <= 0 || paginationItem > paginationNumber) return;
      setPageNumberActive(paginationItem);
      renderPageNumbersItems(paginationItem);
      paginationItem -= 1;
      setSkip( 8 * paginationItem);
    }

    const handleSubcribe = (e) =>{
      try {
        e.preventDefault();
        setDisableBtn(true);
        saveEmail();
      } catch (error) {
        console.log('Error al enviar correo' + error );
      }
    }

  return ( 
    <React.Fragment>
        {loading ? 
          <div className="container">
            <div className="row">
              <div className="col d-flex justify-content-center my-5">
                <div class="spinner-border text-danger" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </div>
          :
          <div className="module ptb-100">
            <div className="container">
              <div className="row">
                <h1 className="color-secondary mb-0">Equipo Frisbee</h1>
              </div>
              <div className="row">
                <div className="post-preview">
                  <img className="mx-auto"src="img/Frisbee_Careers_Banner.png" alt="blog" />
                </div>
              </div>
              <div className="row ptb-100">
                <div className="col-lg-4 col-md-4">
                  <div className="sidebar-left pr-4">

                  <aside className="widget widget-categories">
                      <div className="widget-title">
                          <h6>Regístrate en nuestro Talent Network</h6>
                      </div>
                      <p>
                        Déjanos tu email para no perderte ninguna futura posición en Frisbee.
                      </p>
                      <form
                          action="/#"
                          method="job"
                          className="d-none d-md-block d-lg-block"
                          onChange={ (e) => setSubscribeEmail(e.target.value) }
                          onSubmit={ e => handleSubcribe(e) }
                      >
                          <input
                          type="text"
                          className="form-control input"
                          id="email-footer"
                          name="email"
                          placeholder="info@yourdomain.com"
                          value={subcribeEmail}
                          />
                          <button
                          type="submit"
                          className="btn solid-btn btn-block btn-not-rounded mt-3"
                          disabled={disableBtn}
                          >
                          Regístrate
                          </button>
                      </form>
                      { emailSubmitted ? <span class="badge badge-pill badge-success ml-3 badgeNewsLetter position-static">Enviado!</span>:null}
                      { emailSubscribeError !== "" ? emailSubscribeError : null}
                  </aside>

                  </div>
                </div>
                <div className="col-lg-8 col-md-8">
                  {
                    jobs.length !== 0 ?
                    <>
                      {
                        jobs.map( (job,index) =>(
                          <article className="post">
                            <div className="post-preview">
                              <Link to={`/equipo-frisbee/${toSlugCase(format( new Date(job.fields.date),'yy MM'))}/${toSlugCase(job.fields.title)}/${job.sys.id}`}>
                                <img src={job.fields.thumbnail.fields.file.url} alt="blog"  />
                              </Link>
                            </div>
                            <div className="post-wrapper">
                              <div className="post-header">
                                <h2 className="post-title">
                                  <Link  to={`/equipo-frisbee/${toSlugCase(format( new Date(job.fields.date),'yy MM'))}/${toSlugCase(job.fields.title)}/${job.sys.id}`}>
                                    {job.fields.title}
                                  </Link>
                                </h2>
                                <ul className="post-meta">
                                  <li>{format(new Date(job.fields.date),'MMM dd yyyy')}</li>
                                  <li>
                                    {job.fields.department}
                                  </li>
                                </ul>
                              </div>
                              <div className="post-content">
                                <p>
                                  {job.fields.shortDescription}
                                </p>
                              </div>
                              <div className="post-more pt-4 align-items-center d-flex">
                                <Link className="btn solid-btn" to={`/equipo-frisbee/${toSlugCase(format( new Date(job.fields.date),'yy MM'))}/${toSlugCase(job.fields.title)}/${job.sys.id}`}>
                                  Read more <span className="ti-arrow-right"></span>
                                </Link>
                              </div>
                            </div>
                          </article>
                        ))
                      }
                      <div className="row">
                        <div className="col-md-12">
                          <nav className="custom-pagination-nav mt-4">
                            <ul className="pagination justify-content-center">
                              <li className="page-item">
                                <a className="page-link" onClick={ () => skipPage(pageNumberActive - 1 )} >
                                  <span className="ti-angle-left"></span>
                                </a>
                              </li>
                              {paginationItems}
                              <li className="page-item">
                                <a className="page-link" onClick={ () => skipPage(pageNumberActive + 1 )}>
                                  <span className="ti-angle-right"></span>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>             
                    </>
                    : 
                    <div className="container">
                      <div className="row">
                        <div className="col d-flex justify-content-center my-5">
                          <p>En el momento no hay vacantes, regístrate en nuestra mailing list y conoce nuestras futuras oportunidades laborales!</p>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
      }
      </React.Fragment>
  );
}
 
export default Job;